import initialState from './initialState';
import actionTypes from './actionTypes';

const groupFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_GROUP_FILTER_SUCCESS: {
            if (action.payload) {
                return {
                    ...state,
                    sourceRefId: action.payload.source_ref_id,
                    groupRefId: action.payload.group_ref_id,
                    query: action.payload.query,
                    uiFieldObject: action.payload.ui_field_object,
                };
            }
            return {
                ...state,
                ...initialState,
            };
        }
        default:
            return state;
    }
};

export default groupFilterReducer;
